import React, { useState } from 'react';

import { Input, Button, message } from 'antd';

import './change-password.less';
import {changePassword} from '../../../helpers/api';

export function ChangePassword({ loginStore }) {
  const [password, setPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [newPassword2, setNewPassword2] = useState();
  const [loading, setLoading] = useState(false);

  const changePassword = async () => {
    if(loading) return ;

    if(!password || password.trim().length < 6) {
      return message.error('Введите текущий пароль');
    }

    if(!newPassword) {
      return message.error('Введите новый пароль');
    }

    if(newPassword.trim().length < 6) {
      return message.error('Пароль должен содержать не менее 6 символов');
    }

    if(newPassword !== newPassword2) {
      return message.error('Пароли не совпадают')
    }

    setLoading(true);
    await loginStore.changePassword(password, newPassword);
    setLoading(false);
  };

  return (
    <div className="change-password">
      <h2>Смена пароля админа</h2>
      <div>
        <label>Текущий пароль</label>
        <Input.Password placeholder="Введите текущий пароль" value={password} onChange={({ target: { value }}) => setPassword(value) } />
      </div>
      <div>
        <label>Новый пароль</label>
        <Input.Password placeholder="Введите новый пароль" value={newPassword} onChange={({ target: { value }}) => setNewPassword(value) } />
      </div>
      <div>
        <label>Повторите пароль</label>
        <Input.Password placeholder="Повторите пароль" value={newPassword2} onChange={({ target: { value }}) => setNewPassword2(value) } />
      </div>

      <div>
        <Button type={'primary'} loading={loading} onClick={changePassword}>Изменить пароль</Button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/change-password.js